import Link from 'next/link';

import { Icon } from '@/components/Icon/Icon';
import { cn } from '@/utils/ui';

interface SearchIconProps {
  isSearchActive?: boolean;
  className?: string;
}

export function SearchIcon(props: SearchIconProps): React.ReactNode {
  const { isSearchActive = false, className = '' } = props;

  if (!isSearchActive) {
    return null;
  }

  return (
    <Link
      data-testid="SearchIcon"
      data-analytics="header-account-nav-search-button"
      className={cn(
        "relative flex-col items-center justify-center after:absolute after:block after:p-3 after:content-[''] focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 after:md:p-5",
        className,
      )}
      href="/search"
    >
      <Icon className="size-6" color="white" id="search" />
    </Link>
  );
}
